import { Component } from '@angular/core';

@Component({
  selector: 'app-view-svg',
  standalone: true,
  template: `
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 5.5354C15.5588 5.5354 18.125 10.6667 18.125 10.6667C18.125 10.6667 15.5588 15.7979 10 15.7979C4.44125 15.7979 1.875 10.6667 1.875 10.6667C1.875 10.6667 4.44125 5.5354 10 5.5354Z"
        stroke="#EA5B0C"
        stroke-width="1.16125"
        stroke-linejoin="round"
      />
      <path
        d="M12.4252 10.6666C12.4326 10.9996 12.3735 11.3306 12.2512 11.6404C12.1289 11.9501 11.946 12.2323 11.7132 12.4704C11.4804 12.7085 11.2023 12.8977 10.8954 13.0268C10.5884 13.156 10.2588 13.2225 9.92578 13.2225C9.59277 13.2225 9.26312 13.156 8.95618 13.0268C8.64923 12.8977 8.37119 12.7085 8.13836 12.4704C7.90553 12.2323 7.72262 11.9501 7.60036 11.6404C7.4781 11.3306 7.41896 10.9996 7.42641 10.6666C7.42641 10.0036 7.6898 9.3677 8.15864 8.89886C8.62748 8.43002 9.26336 8.16663 9.92641 8.16663C10.5894 8.16663 11.2253 8.43002 11.6942 8.89886C12.163 9.3677 12.4264 10.0036 12.4264 10.6666H12.4252Z"
        stroke="#EA5B0C"
        stroke-width="1.16125"
        stroke-linejoin="round"
      />
    </svg>
  `,
})
export class ViewSvgComponent {}
